import View from "./password-fields.view";
import Presenter from "./password-fields.presenter";
import { ConnectComponent } from "util";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/password-fields/index.js